import React, { useState, useContext, useEffect } from "react";

import {
  InputCopy,
  FormGroup,
  Dropdown,
  FormFooter,
  Select,
  Tooltip,
  StatusDot,
  ContentBlock,
  Breadcrumbs,
  Checkbox,
  Subheader,
  Pill,
  Collapse,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  Popover,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";
import { PAinfoCollapsible } from "./../PAconnectors";

import {
  PAgkRefundPeriods,
  PAgkRefundOption,
  SelectSquare,
  PAgkRefundLine,
  CssTableFlag,
  CssTableCountry
} from "../ffr/PAgkRefund";

import merge from "deepmerge";

import DatePickerExample from "./../DatePicker";
import SelectExample from "./../SelectExample";
import { timezones, years } from "./PAgameKeys";





export function PAphysical({ handleChange = ()=>void(0) }) {


  const [phys, setPhys] = useState('dig')
  const [physType, setPhysType] = useState(0)

  return (
    <FormGroup indentation="lg">

  <FormGroup label="Item type" indentation="sm">
      <RadioGroup
        direction="row"
        input={{
          value: phys,
          onChange: e => {
            setPhys(e.target.value)
            handleChange(e.target.value)
          }
        }}
        options={[
          {
            radioValue: 'dig',
            label: "Digital good"
          },
          {
            radioValue: 'phys',
            label: "Physical good"
            // tooltip: "Tooltip message"
          }
        ]}
      />
  </FormGroup>

  {phys === 'phys' &&
  <FormGroup label="Good type">

      <Select
        // disabled={this.disabled}
        autosize={true}
        // size="sm"
        name=""
        options={[
          { label: "Shirt", id: "all", value: 0, extraLabel: 'Under 1 kg.' },
          { label: "DVD-disk", id: "wepons", value: 1,},
          { label: "Keyring", id: "armor", value: 2,  },
          { label: "Shirt", id: "all", value: 3, },
          { label: "DVD-disk", id: "wepons", value: 4, },
          { label: "Keyring", id: "armor", value: 5,  },
        ]}
        searchable={false}
        autosize={false}
        disabled={false}
        input={{
          value: physType,
          name: "test",
          onChange: val => {
            setPhysType(val)
          },
        }}
      />


  </FormGroup>}




    </FormGroup>
  );
}
